import Qe, { useMemo as Or } from "react";
function Mr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var er = {}, rr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    return Array.isArray(n) ? n.map((a) => t(a)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([a, c]) => [
      a,
      t(c)
    ])) : n;
  }
})(rr);
var Ar = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: e }) => ({
      ...e("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: e }) => e("blur"),
    backdropBrightness: ({ theme: e }) => e("brightness"),
    backdropContrast: ({ theme: e }) => e("contrast"),
    backdropGrayscale: ({ theme: e }) => e("grayscale"),
    backdropHueRotate: ({ theme: e }) => e("hueRotate"),
    backdropInvert: ({ theme: e }) => e("invert"),
    backdropOpacity: ({ theme: e }) => e("opacity"),
    backdropSaturate: ({ theme: e }) => e("saturate"),
    backdropSepia: ({ theme: e }) => e("sepia"),
    backgroundColor: ({ theme: e }) => e("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: e }) => e("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "0",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: e }) => ({
      ...e("colors"),
      DEFAULT: e("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: e }) => e("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: e }) => ({
      ...e("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: e }) => e("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: e }) => e("colors"),
    colors: ({ colors: e }) => ({
      inherit: e.inherit,
      current: e.current,
      transparent: e.transparent,
      black: e.black,
      white: e.white,
      slate: e.slate,
      gray: e.gray,
      zinc: e.zinc,
      neutral: e.neutral,
      stone: e.stone,
      red: e.red,
      orange: e.orange,
      amber: e.amber,
      yellow: e.yellow,
      lime: e.lime,
      green: e.green,
      emerald: e.emerald,
      teal: e.teal,
      cyan: e.cyan,
      sky: e.sky,
      blue: e.blue,
      indigo: e.indigo,
      violet: e.violet,
      purple: e.purple,
      fuchsia: e.fuchsia,
      pink: e.pink,
      rose: e.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: e }) => e("borderColor"),
    divideOpacity: ({ theme: e }) => e("borderOpacity"),
    divideWidth: ({ theme: e }) => e("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: e }) => e("spacing"),
    gradientColorStops: ({ theme: e }) => e("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: e }) => ({
      ...e("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: e, breakpoints: t }) => ({
      ...e("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...t(e("screens"))
    }),
    minHeight: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: e }) => e("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: e }) => e("spacing"),
    placeholderColor: ({ theme: e }) => e("colors"),
    placeholderOpacity: ({ theme: e }) => e("opacity"),
    ringColor: ({ theme: e }) => ({
      DEFAULT: e("colors.blue.500", "#3b82f6"),
      ...e("colors")
    }),
    ringOffsetColor: ({ theme: e }) => e("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: e }) => ({
      DEFAULT: "0.5",
      ...e("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: e }) => ({
      ...e("spacing")
    }),
    scrollPadding: ({ theme: e }) => e("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: e }) => ({
      ...e("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: e }) => e("colors"),
    textDecorationColor: ({ theme: e }) => e("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: e }) => ({
      ...e("spacing")
    }),
    textOpacity: ({ theme: e }) => e("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: e }) => ({
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return c;
    }
  });
  const t = rr, n = /* @__PURE__ */ a(Ar);
  function a(s) {
    return s && s.__esModule ? s : {
      default: s
    };
  }
  const c = (0, t.cloneDeep)(n.default.theme);
})(er);
let Se = er;
var Fr = (Se.__esModule ? Se : { default: Se }).default;
const Be = /* @__PURE__ */ Mr(Fr), At = {
  colors: {
    "dark-gray": "#1B1B1B",
    "light-gray": "#292929",
    "lighter-gray": "#676767",
    red: "#BE3E22",
    yellow: "#D19C4C",
    green: "#54C186"
  },
  fontFamily: {
    sans: ['"MD Primer"', ...Be.fontFamily.sans],
    serif: ['"PP Eiko"', ...Be.fontFamily.serif]
  }
};
var Te = { exports: {} }, ae = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qe;
function Hr() {
  if (qe)
    return ae;
  qe = 1;
  var e = Qe, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, c = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, p, x) {
    var m, C = {}, S = null, P = null;
    x !== void 0 && (S = "" + x), p.key !== void 0 && (S = "" + p.key), p.ref !== void 0 && (P = p.ref);
    for (m in p)
      a.call(p, m) && !s.hasOwnProperty(m) && (C[m] = p[m]);
    if (u && u.defaultProps)
      for (m in p = u.defaultProps, p)
        C[m] === void 0 && (C[m] = p[m]);
    return { $$typeof: t, type: u, key: S, ref: P, props: C, _owner: c.current };
  }
  return ae.Fragment = n, ae.jsx = l, ae.jsxs = l, ae;
}
var ie = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Je;
function Nr() {
  return Je || (Je = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Qe, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), C = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), P = Symbol.for("react.offscreen"), H = Symbol.iterator, E = "@@iterator";
    function T(r) {
      if (r === null || typeof r != "object")
        return null;
      var o = H && r[H] || r[E];
      return typeof o == "function" ? o : null;
    }
    var z = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(r) {
      {
        for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), d = 1; d < o; d++)
          i[d - 1] = arguments[d];
        ce("error", r, i);
      }
    }
    function ce(r, o, i) {
      {
        var d = z.ReactDebugCurrentFrame, h = d.getStackAddendum();
        h !== "" && (o += "%s", i = i.concat([h]));
        var y = i.map(function(b) {
          return String(b);
        });
        y.unshift("Warning: " + o), Function.prototype.apply.call(console[r], console, y);
      }
    }
    var Q = !1, ue = !1, de = !1, pe = !1, fe = !1, B;
    B = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === a || r === s || fe || r === c || r === x || r === m || pe || r === P || Q || ue || de || typeof r == "object" && r !== null && (r.$$typeof === S || r.$$typeof === C || r.$$typeof === l || r.$$typeof === u || r.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === B || r.getModuleId !== void 0));
    }
    function re(r, o, i) {
      var d = r.displayName;
      if (d)
        return d;
      var h = o.displayName || o.name || "";
      return h !== "" ? i + "(" + h + ")" : i;
    }
    function v(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case c:
          return "StrictMode";
        case x:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            var o = r;
            return v(o) + ".Consumer";
          case l:
            var i = r;
            return v(i._context) + ".Provider";
          case p:
            return re(r, r.render, "ForwardRef");
          case C:
            var d = r.displayName || null;
            return d !== null ? d : O(r.type) || "Memo";
          case S: {
            var h = r, y = h._payload, b = h._init;
            try {
              return O(b(y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, D = 0, G, te, q, I, ne, W, Y;
    function Oe() {
    }
    Oe.__reactDisabledLog = !0;
    function lr() {
      {
        if (D === 0) {
          G = console.log, te = console.info, q = console.warn, I = console.error, ne = console.group, W = console.groupCollapsed, Y = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: Oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        D++;
      }
    }
    function cr() {
      {
        if (D--, D === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, r, {
              value: G
            }),
            info: M({}, r, {
              value: te
            }),
            warn: M({}, r, {
              value: q
            }),
            error: M({}, r, {
              value: I
            }),
            group: M({}, r, {
              value: ne
            }),
            groupCollapsed: M({}, r, {
              value: W
            }),
            groupEnd: M({}, r, {
              value: Y
            })
          });
        }
        D < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ye = z.ReactCurrentDispatcher, Ce;
    function me(r, o, i) {
      {
        if (Ce === void 0)
          try {
            throw Error();
          } catch (h) {
            var d = h.stack.trim().match(/\n( *(at )?)/);
            Ce = d && d[1] || "";
          }
        return `
` + Ce + r;
      }
    }
    var we = !1, ge;
    {
      var ur = typeof WeakMap == "function" ? WeakMap : Map;
      ge = new ur();
    }
    function Me(r, o) {
      if (!r || we)
        return "";
      {
        var i = ge.get(r);
        if (i !== void 0)
          return i;
      }
      var d;
      we = !0;
      var h = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var y;
      y = ye.current, ye.current = null, lr();
      try {
        if (o) {
          var b = function() {
            throw Error();
          };
          if (Object.defineProperty(b.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b, []);
            } catch (N) {
              d = N;
            }
            Reflect.construct(r, [], b);
          } else {
            try {
              b.call();
            } catch (N) {
              d = N;
            }
            r.call(b.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (N) {
            d = N;
          }
          r();
        }
      } catch (N) {
        if (N && d && typeof N.stack == "string") {
          for (var g = N.stack.split(`
`), j = d.stack.split(`
`), k = g.length - 1, R = j.length - 1; k >= 1 && R >= 0 && g[k] !== j[R]; )
            R--;
          for (; k >= 1 && R >= 0; k--, R--)
            if (g[k] !== j[R]) {
              if (k !== 1 || R !== 1)
                do
                  if (k--, R--, R < 0 || g[k] !== j[R]) {
                    var A = `
` + g[k].replace(" at new ", " at ");
                    return r.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", r.displayName)), typeof r == "function" && ge.set(r, A), A;
                  }
                while (k >= 1 && R >= 0);
              break;
            }
        }
      } finally {
        we = !1, ye.current = y, cr(), Error.prepareStackTrace = h;
      }
      var X = r ? r.displayName || r.name : "", Ze = X ? me(X) : "";
      return typeof r == "function" && ge.set(r, Ze), Ze;
    }
    function dr(r, o, i) {
      return Me(r, !1);
    }
    function pr(r) {
      var o = r.prototype;
      return !!(o && o.isReactComponent);
    }
    function be(r, o, i) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Me(r, pr(r));
      if (typeof r == "string")
        return me(r);
      switch (r) {
        case x:
          return me("Suspense");
        case m:
          return me("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case p:
            return dr(r.render);
          case C:
            return be(r.type, o, i);
          case S: {
            var d = r, h = d._payload, y = d._init;
            try {
              return be(y(h), o, i);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ae = {}, Fe = z.ReactDebugCurrentFrame;
    function xe(r) {
      if (r) {
        var o = r._owner, i = be(r.type, r._source, o ? o.type : null);
        Fe.setExtraStackFrame(i);
      } else
        Fe.setExtraStackFrame(null);
    }
    function fr(r, o, i, d, h) {
      {
        var y = Function.call.bind(he);
        for (var b in r)
          if (y(r, b)) {
            var g = void 0;
            try {
              if (typeof r[b] != "function") {
                var j = Error((d || "React class") + ": " + i + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw j.name = "Invariant Violation", j;
              }
              g = r[b](o, b, d, i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (k) {
              g = k;
            }
            g && !(g instanceof Error) && (xe(h), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", d || "React class", i, b, typeof g), xe(null)), g instanceof Error && !(g.message in Ae) && (Ae[g.message] = !0, xe(h), w("Failed %s type: %s", i, g.message), xe(null));
          }
      }
    }
    var mr = Array.isArray;
    function Le(r) {
      return mr(r);
    }
    function gr(r) {
      {
        var o = typeof Symbol == "function" && Symbol.toStringTag, i = o && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return i;
      }
    }
    function br(r) {
      try {
        return He(r), !1;
      } catch {
        return !0;
      }
    }
    function He(r) {
      return "" + r;
    }
    function Ne(r) {
      if (br(r))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", gr(r)), He(r);
    }
    var oe = z.ReactCurrentOwner, hr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ve, De, ke;
    ke = {};
    function xr(r) {
      if (he.call(r, "ref")) {
        var o = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (o && o.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function vr(r) {
      if (he.call(r, "key")) {
        var o = Object.getOwnPropertyDescriptor(r, "key").get;
        if (o && o.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function yr(r, o) {
      if (typeof r.ref == "string" && oe.current && o && oe.current.stateNode !== o) {
        var i = O(oe.current.type);
        ke[i] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(oe.current.type), r.ref), ke[i] = !0);
      }
    }
    function Cr(r, o) {
      {
        var i = function() {
          Ve || (Ve = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
        };
        i.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: i,
          configurable: !0
        });
      }
    }
    function wr(r, o) {
      {
        var i = function() {
          De || (De = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
        };
        i.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: i,
          configurable: !0
        });
      }
    }
    var Lr = function(r, o, i, d, h, y, b) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: r,
        key: o,
        ref: i,
        props: b,
        // Record the component responsible for creating this element.
        _owner: y
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(g, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.defineProperty(g, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function kr(r, o, i, d, h) {
      {
        var y, b = {}, g = null, j = null;
        i !== void 0 && (Ne(i), g = "" + i), vr(o) && (Ne(o.key), g = "" + o.key), xr(o) && (j = o.ref, yr(o, h));
        for (y in o)
          he.call(o, y) && !hr.hasOwnProperty(y) && (b[y] = o[y]);
        if (r && r.defaultProps) {
          var k = r.defaultProps;
          for (y in k)
            b[y] === void 0 && (b[y] = k[y]);
        }
        if (g || j) {
          var R = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          g && Cr(b, R), j && wr(b, R);
        }
        return Lr(r, g, j, h, d, oe.current, b);
      }
    }
    var Ee = z.ReactCurrentOwner, Ie = z.ReactDebugCurrentFrame;
    function J(r) {
      if (r) {
        var o = r._owner, i = be(r.type, r._source, o ? o.type : null);
        Ie.setExtraStackFrame(i);
      } else
        Ie.setExtraStackFrame(null);
    }
    var Re;
    Re = !1;
    function _e(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
    function We() {
      {
        if (Ee.current) {
          var r = O(Ee.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Er(r) {
      {
        if (r !== void 0) {
          var o = r.fileName.replace(/^.*[\\\/]/, ""), i = r.lineNumber;
          return `

Check your code at ` + o + ":" + i + ".";
        }
        return "";
      }
    }
    var Ue = {};
    function Rr(r) {
      {
        var o = We();
        if (!o) {
          var i = typeof r == "string" ? r : r.displayName || r.name;
          i && (o = `

Check the top-level render call using <` + i + ">.");
        }
        return o;
      }
    }
    function $e(r, o) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var i = Rr(o);
        if (Ue[i])
          return;
        Ue[i] = !0;
        var d = "";
        r && r._owner && r._owner !== Ee.current && (d = " It was passed a child from " + O(r._owner.type) + "."), J(r), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', i, d), J(null);
      }
    }
    function Ge(r, o) {
      {
        if (typeof r != "object")
          return;
        if (Le(r))
          for (var i = 0; i < r.length; i++) {
            var d = r[i];
            _e(d) && $e(d, o);
          }
        else if (_e(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var h = T(r);
          if (typeof h == "function" && h !== r.entries)
            for (var y = h.call(r), b; !(b = y.next()).done; )
              _e(b.value) && $e(b.value, o);
        }
      }
    }
    function _r(r) {
      {
        var o = r.type;
        if (o == null || typeof o == "string")
          return;
        var i;
        if (typeof o == "function")
          i = o.propTypes;
        else if (typeof o == "object" && (o.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        o.$$typeof === C))
          i = o.propTypes;
        else
          return;
        if (i) {
          var d = O(o);
          fr(i, r.props, "prop", d, r);
        } else if (o.PropTypes !== void 0 && !Re) {
          Re = !0;
          var h = O(o);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", h || "Unknown");
        }
        typeof o.getDefaultProps == "function" && !o.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Sr(r) {
      {
        for (var o = Object.keys(r.props), i = 0; i < o.length; i++) {
          var d = o[i];
          if (d !== "children" && d !== "key") {
            J(r), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", d), J(null);
            break;
          }
        }
        r.ref !== null && (J(r), w("Invalid attribute `ref` supplied to `React.Fragment`."), J(null));
      }
    }
    function Ye(r, o, i, d, h, y) {
      {
        var b = ee(r);
        if (!b) {
          var g = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var j = Er(h);
          j ? g += j : g += We();
          var k;
          r === null ? k = "null" : Le(r) ? k = "array" : r !== void 0 && r.$$typeof === t ? (k = "<" + (O(r.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : k = typeof r, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", k, g);
        }
        var R = kr(r, o, i, h, y);
        if (R == null)
          return R;
        if (b) {
          var A = o.children;
          if (A !== void 0)
            if (d)
              if (Le(A)) {
                for (var X = 0; X < A.length; X++)
                  Ge(A[X], r);
                Object.freeze && Object.freeze(A);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ge(A, r);
        }
        return r === a ? Sr(R) : _r(R), R;
      }
    }
    function Tr(r, o, i) {
      return Ye(r, o, i, !0);
    }
    function zr(r, o, i) {
      return Ye(r, o, i, !1);
    }
    var jr = zr, Pr = Tr;
    ie.Fragment = a, ie.jsx = jr, ie.jsxs = Pr;
  }()), ie;
}
process.env.NODE_ENV === "production" ? Te.exports = Hr() : Te.exports = Nr();
var _ = Te.exports;
const Pe = "-";
function Vr(e) {
  const t = Ir(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: a
  } = e;
  function c(l) {
    const u = l.split(Pe);
    return u[0] === "" && u.length !== 1 && u.shift(), tr(u, t) || Dr(l);
  }
  function s(l, u) {
    const p = n[l] || [];
    return u && a[l] ? [...p, ...a[l]] : p;
  }
  return {
    getClassGroupId: c,
    getConflictingClassGroupIds: s
  };
}
function tr(e, t) {
  var l;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], a = t.nextPart.get(n), c = a ? tr(e.slice(1), a) : void 0;
  if (c)
    return c;
  if (t.validators.length === 0)
    return;
  const s = e.join(Pe);
  return (l = t.validators.find(({
    validator: u
  }) => u(s))) == null ? void 0 : l.classGroupId;
}
const Xe = /^\[(.+)\]$/;
function Dr(e) {
  if (Xe.test(e)) {
    const t = Xe.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function Ir(e) {
  const {
    theme: t,
    prefix: n
  } = e, a = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Ur(Object.entries(e.classGroups), n).forEach(([s, l]) => {
    ze(l, a, s, t);
  }), a;
}
function ze(e, t, n, a) {
  e.forEach((c) => {
    if (typeof c == "string") {
      const s = c === "" ? t : Ke(t, c);
      s.classGroupId = n;
      return;
    }
    if (typeof c == "function") {
      if (Wr(c)) {
        ze(c(a), t, n, a);
        return;
      }
      t.validators.push({
        validator: c,
        classGroupId: n
      });
      return;
    }
    Object.entries(c).forEach(([s, l]) => {
      ze(l, Ke(t, s), n, a);
    });
  });
}
function Ke(e, t) {
  let n = e;
  return t.split(Pe).forEach((a) => {
    n.nextPart.has(a) || n.nextPart.set(a, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(a);
  }), n;
}
function Wr(e) {
  return e.isThemeGetter;
}
function Ur(e, t) {
  return t ? e.map(([n, a]) => {
    const c = a.map((s) => typeof s == "string" ? t + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([l, u]) => [t + l, u])) : s);
    return [n, c];
  }) : e;
}
function $r(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  function c(s, l) {
    n.set(s, l), t++, t > e && (t = 0, a = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(s) {
      let l = n.get(s);
      if (l !== void 0)
        return l;
      if ((l = a.get(s)) !== void 0)
        return c(s, l), l;
    },
    set(s, l) {
      n.has(s) ? n.set(s, l) : c(s, l);
    }
  };
}
const nr = "!";
function Gr(e) {
  const t = e.separator, n = t.length === 1, a = t[0], c = t.length;
  return function(l) {
    const u = [];
    let p = 0, x = 0, m;
    for (let E = 0; E < l.length; E++) {
      let T = l[E];
      if (p === 0) {
        if (T === a && (n || l.slice(E, E + c) === t)) {
          u.push(l.slice(x, E)), x = E + c;
          continue;
        }
        if (T === "/") {
          m = E;
          continue;
        }
      }
      T === "[" ? p++ : T === "]" && p--;
    }
    const C = u.length === 0 ? l : l.substring(x), S = C.startsWith(nr), P = S ? C.substring(1) : C, H = m && m > x ? m - x : void 0;
    return {
      modifiers: u,
      hasImportantModifier: S,
      baseClassName: P,
      maybePostfixModifierPosition: H
    };
  };
}
function Yr(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((a) => {
    a[0] === "[" ? (t.push(...n.sort(), a), n = []) : n.push(a);
  }), t.push(...n.sort()), t;
}
function Zr(e) {
  return {
    cache: $r(e.cacheSize),
    splitModifiers: Gr(e),
    ...Vr(e)
  };
}
const Br = /\s+/;
function qr(e, t) {
  const {
    splitModifiers: n,
    getClassGroupId: a,
    getConflictingClassGroupIds: c
  } = t, s = /* @__PURE__ */ new Set();
  return e.trim().split(Br).map((l) => {
    const {
      modifiers: u,
      hasImportantModifier: p,
      baseClassName: x,
      maybePostfixModifierPosition: m
    } = n(l);
    let C = a(m ? x.substring(0, m) : x), S = !!m;
    if (!C) {
      if (!m)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      if (C = a(x), !C)
        return {
          isTailwindClass: !1,
          originalClassName: l
        };
      S = !1;
    }
    const P = Yr(u).join(":");
    return {
      isTailwindClass: !0,
      modifierId: p ? P + nr : P,
      classGroupId: C,
      originalClassName: l,
      hasPostfixModifier: S
    };
  }).reverse().filter((l) => {
    if (!l.isTailwindClass)
      return !0;
    const {
      modifierId: u,
      classGroupId: p,
      hasPostfixModifier: x
    } = l, m = u + p;
    return s.has(m) ? !1 : (s.add(m), c(p, x).forEach((C) => s.add(u + C)), !0);
  }).reverse().map((l) => l.originalClassName).join(" ");
}
function Jr() {
  let e = 0, t, n, a = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = or(t)) && (a && (a += " "), a += n);
  return a;
}
function or(e) {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let a = 0; a < e.length; a++)
    e[a] && (t = or(e[a])) && (n && (n += " "), n += t);
  return n;
}
function Xr(e, ...t) {
  let n, a, c, s = l;
  function l(p) {
    const x = t.reduce((m, C) => C(m), e());
    return n = Zr(x), a = n.cache.get, c = n.cache.set, s = u, u(p);
  }
  function u(p) {
    const x = a(p);
    if (x)
      return x;
    const m = qr(p, n);
    return c(p, m), m;
  }
  return function() {
    return s(Jr.apply(null, arguments));
  };
}
function L(e) {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}
const ar = /^\[(?:([a-z-]+):)?(.+)\]$/i, Kr = /^\d+\/\d+$/, Qr = /* @__PURE__ */ new Set(["px", "full", "screen"]), et = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, rt = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, tt = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, nt = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ot = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function V(e) {
  return Z(e) || Qr.has(e) || Kr.test(e);
}
function U(e) {
  return K(e, "length", pt);
}
function Z(e) {
  return !!e && !Number.isNaN(Number(e));
}
function ve(e) {
  return K(e, "number", Z);
}
function se(e) {
  return !!e && Number.isInteger(Number(e));
}
function at(e) {
  return e.endsWith("%") && Z(e.slice(0, -1));
}
function f(e) {
  return ar.test(e);
}
function $(e) {
  return et.test(e);
}
const it = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function st(e) {
  return K(e, it, ir);
}
function lt(e) {
  return K(e, "position", ir);
}
const ct = /* @__PURE__ */ new Set(["image", "url"]);
function ut(e) {
  return K(e, ct, mt);
}
function dt(e) {
  return K(e, "", ft);
}
function le() {
  return !0;
}
function K(e, t, n) {
  const a = ar.exec(e);
  return a ? a[1] ? typeof t == "string" ? a[1] === t : t.has(a[1]) : n(a[2]) : !1;
}
function pt(e) {
  return rt.test(e) && !tt.test(e);
}
function ir() {
  return !1;
}
function ft(e) {
  return nt.test(e);
}
function mt(e) {
  return ot.test(e);
}
function gt() {
  const e = L("colors"), t = L("spacing"), n = L("blur"), a = L("brightness"), c = L("borderColor"), s = L("borderRadius"), l = L("borderSpacing"), u = L("borderWidth"), p = L("contrast"), x = L("grayscale"), m = L("hueRotate"), C = L("invert"), S = L("gap"), P = L("gradientColorStops"), H = L("gradientColorStopPositions"), E = L("inset"), T = L("margin"), z = L("opacity"), w = L("padding"), ce = L("saturate"), Q = L("scale"), ue = L("sepia"), de = L("skew"), pe = L("space"), fe = L("translate"), B = () => ["auto", "contain", "none"], ee = () => ["auto", "hidden", "clip", "visible", "scroll"], re = () => ["auto", f, t], v = () => [f, t], O = () => ["", V, U], M = () => ["auto", Z, f], D = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], G = () => ["solid", "dashed", "dotted", "double", "none"], te = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], q = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], I = () => ["", "0", f], ne = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], W = () => [Z, ve], Y = () => [Z, f];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [le],
      spacing: [V, U],
      blur: ["none", "", $, f],
      brightness: W(),
      borderColor: [e],
      borderRadius: ["none", "", "full", $, f],
      borderSpacing: v(),
      borderWidth: O(),
      contrast: W(),
      grayscale: I(),
      hueRotate: Y(),
      invert: I(),
      gap: v(),
      gradientColorStops: [e],
      gradientColorStopPositions: [at, U],
      inset: re(),
      margin: re(),
      opacity: W(),
      padding: v(),
      saturate: W(),
      scale: W(),
      sepia: I(),
      skew: Y(),
      space: v(),
      translate: v()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", f]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [$]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ne()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ne()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...D(), f]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: ee()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": ee()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": ee()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [E]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [E]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [E]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [E]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [E]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [E]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [E]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [E]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [E]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", se, f]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: re()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", f]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: I()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: I()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", se, f]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [le]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", se, f]
        }, f]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": M()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": M()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [le]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [se, f]
        }, f]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": M()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": M()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", f]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", f]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [S]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [S]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [S]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...q()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...q(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...q(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [T]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [T]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [T]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [T]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [T]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [T]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [T]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [T]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [T]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [pe]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [pe]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", f, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [f, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [f, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [$]
        }, $]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [f, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [f, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [f, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [f, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", $, U]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ve]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [le]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", f]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Z, ve]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", V, f]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", f]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", f]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [z]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [z]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...G(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", V, U]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", V, f]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: v()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", f]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", f]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [z]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...D(), lt]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", st]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, ut]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [H]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [H]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [H]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [P]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [P]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [P]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [u]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [u]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [u]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [u]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [u]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [u]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [u]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [u]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [u]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [z]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...G(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [u]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [u]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [z]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: G()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [c]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [c]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [c]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [c]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [c]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [c]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [c]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [c]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...G()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [V, f]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [V, U]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: O()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [z]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [V, U]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", $, dt]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [le]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [z]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": te()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": te()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [a]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [p]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", $, f]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [x]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [m]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [C]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [ce]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [ue]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [a]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [p]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [x]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [m]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [C]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [z]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [ce]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [ue]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [l]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [l]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [l]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", f]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Y()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", f]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Y()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", f]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [Q]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [Q]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [Q]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [se, f]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [fe]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [fe]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [de]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [de]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", f]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", f]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": v()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": v()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": v()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": v()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": v()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": v()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": v()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": v()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": v()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": v()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": v()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": v()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": v()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": v()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": v()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": v()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": v()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": v()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", f]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [V, U, ve]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const F = /* @__PURE__ */ Xr(gt), bt = {
  "2xl": "text-[32px] leading-[38px]",
  xl: "text-2xl leading-[29px]",
  lg: "text-xl leading-6",
  md: "text-base leading-[19px]",
  sm: "text-sm leading-[17px]",
  xs: "text-xs leading-[14px]"
}, ht = {
  bold: "font-bold",
  medium: "font-medium",
  regular: "font-normal"
}, je = ({ size: e, weight: t, children: n, className: a }) => {
  const c = bt[e], s = ht[t];
  return /* @__PURE__ */ _.jsx("p", { className: F(c, s, a), children: n });
}, xt = {
  primary: "disabled:bg-lighter-gray bg-white text-black hover:bg-white/90",
  secondary: "bg-white/10 text-white hover:bg-white/20 disabled:bg-white/10",
  tertiary: "bg-transparent text-white/70 hover:text-white disabled:text-white/70"
}, vt = {
  lg: "h-[59px] px-[40px]",
  md: "h-[55px] px-[36px]",
  sm: "h-[37px] px-[20px]"
}, yt = {
  lg: "",
  md: "h-5 w-5",
  sm: "h-4 w-4"
}, Ft = ({
  variant: e,
  size: t,
  loading: n = !1,
  children: a,
  className: c,
  disabled: s,
  ...l
}) => {
  const u = xt[e], p = vt[t], x = t === "sm" ? "sm" : "md", m = yt[t];
  return /* @__PURE__ */ _.jsx(
    "button",
    {
      className: F(
        "flex items-center justify-center rounded transition-colors disabled:cursor-not-allowed",
        u,
        p,
        c
      ),
      disabled: s || n,
      ...l,
      children: n ? /* @__PURE__ */ _.jsx(Ot, { className: m }) : /* @__PURE__ */ _.jsx(je, { size: x, weight: "medium", children: a })
    }
  );
}, Ct = {
  lg: "text-[32px] leading-[38px]",
  md: "text-2xl leading-[29px]",
  sm: "text-xl leading-6"
}, wt = {
  bold: "font-black",
  medium: "font-medium",
  regular: "font-normal"
}, Ht = ({ size: e, weight: t, children: n, className: a }) => {
  const c = Ct[e], s = wt[t];
  return /* @__PURE__ */ _.jsx(
    "p",
    {
      className: F(
        "font-serif font-bold",
        c,
        s,
        a
      ),
      children: n
    }
  );
}, Lt = "data:image/svg+xml,%3csvg%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.25%208.375L6.5%2010.625L11.75%205.375'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Nt = ({ register: e, children: t, className: n }) => /* @__PURE__ */ _.jsxs("label", { className: F("flex cursor-pointer items-center", n), children: [
  /* @__PURE__ */ _.jsx("input", { className: "peer appearance-none", type: "checkbox", ...e }),
  /* @__PURE__ */ _.jsx("div", { className: "mr-3 flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-white bg-black transition-colors peer-checked:bg-white", children: /* @__PURE__ */ _.jsx("img", { src: Lt, className: "h-full w-full" }) }),
  t
] }), kt = {
  lg: "text-sm leading-[17px] tracking-[1.68px]",
  md: "text-xs leading-[14px] tracking-[1.44px]",
  sm: "text-[8px] leading-[10px] tracking-[0.96px]"
}, Vt = ({ size: e, children: t, className: n }) => {
  const a = kt[e];
  return /* @__PURE__ */ _.jsx("p", { className: F("font-medium uppercase", a, n), children: t });
}, Et = /\D/g, sr = "1", Rt = `+${sr}`, _t = (e) => e.length ? `(${e}` : "", St = (e) => e.length ? `) ${e}` : "", Tt = (e) => e.length ? `-${e}` : "", zt = (e) => {
  let n = e.replace(Rt, "").replace(Et, "");
  n.length > 10 && n[0] === sr && (n = n.slice(1));
  const a = n.slice(0, 3), c = n.slice(3, 6), s = n.slice(6, 10), l = _t(a), u = St(c), p = Tt(s);
  return `+1 ${l}${u}${p}`;
}, Dt = ({
  label: e,
  error: t,
  register: n,
  mask: a,
  placeholder: c,
  className: s
}) => {
  const l = (u) => {
    if (a === "phone") {
      const p = zt(u.target.value);
      u.target.value = p;
    }
    n == null || n.onChange(u);
  };
  return /* @__PURE__ */ _.jsxs("div", { className: s, children: [
    e && /* @__PURE__ */ _.jsx(je, { size: "sm", weight: "regular", className: "mb-3 text-white/60", children: e }),
    /* @__PURE__ */ _.jsx(
      "input",
      {
        className: F(
          "w-full rounded border bg-dark-gray p-4 text-white transition-colors placeholder:text-white/60 focus:border-lighter-gray focus:outline-none",
          t ? "border-red" : "border-light-gray"
        ),
        autoComplete: "off",
        placeholder: c,
        ...n,
        onChange: l
      }
    ),
    t && /* @__PURE__ */ _.jsx(je, { size: "sm", weight: "regular", className: "mt-3 text-red", children: t })
  ] });
}, jt = "data:image/svg+xml,%3csvg%20viewBox='0%200%20120%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M97.411%2012.2832V12.2921L93.5115%203.04456H91.9037L92.1613%203.72808L88.5015%2011.9884C88.0041%2013.1097%2087.1025%2014.575%2087.1025%2014.575H88.6792C88.6792%2014.575%2088.577%2013.9719%2088.9013%2013.208C89.412%2012.033%2090.9088%2011.1261%2092.5654%2011.1261C94.2221%2011.1261%2095.7011%2012.1447%2096.2296%2013.3599C96.5183%2014.0166%2096.3362%2014.5705%2096.3362%2014.5705H98.6191C98.6191%2014.5705%2097.8463%2013.3331%2097.4066%2012.2877L97.411%2012.2832ZM92.5699%2010.5275C91.5217%2010.5275%2090.5313%2010.8045%2089.7496%2011.2691L92.6321%204.65283C92.6321%204.65283%2093.7691%207.09205%2094.3465%208.65119L95.0837%2010.6705L95.3724%2011.3406C94.5996%2010.8358%2093.6314%2010.523%2092.5699%2010.523V10.5275Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M87.1158%2011.7963C85.9832%2013.619%2084.562%2014.1372%2082.5989%2014.0612C79.9918%2013.9585%2078.0731%2011.6801%2078.0731%208.745C78.0731%204.425%2080.6358%203.43769%2082.55%203.43769C84.4643%203.43769%2086.1254%204.06313%2086.6894%205.94392L86.7516%205.89478V3.62979C86.2897%203.37515%2085.1172%202.76758%2082.7899%202.76758C79.0813%202.76758%2076.5319%205.51952%2076.5319%208.745C76.5319%2012.2296%2078.9125%2014.843%2082.5722%2014.843C85.2238%2014.843%2086.6761%2013.4626%2087.178%2012.0732L87.1158%2011.7963Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M53.1878%203.06243H48.3067C48.4621%203.62086%2048.5421%204.22843%2048.5421%205.53739V12.109C48.5421%2013.9451%2048.3067%2014.5839%2048.3067%2014.5839H50.3053C50.3053%2014.5839%2050.0965%2014.0255%2050.0699%2012.453V3.81742C50.0699%203.81742%2050.9315%203.78615%2052.1307%203.78615C53.5076%203.78615%2054.9244%204.09441%2054.9244%206.03327C54.9244%207.63708%2053.7963%208.3608%2052.2062%208.39654C51.4023%208.41441%2050.6162%208.42335%2050.0655%208.39654V9.12027C50.9138%209.12027%2051.993%209.13814%2052.9524%209.1158C55.102%209.06219%2056.4478%207.91406%2056.4478%206.03774C56.4478%204.48754%2054.951%203.07136%2053.1789%203.07136L53.1878%203.06243Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M114.257%203.04456H110.051C110.207%203.60299%20110.291%204.21056%20110.291%205.51952V12.0911C110.291%2013.9272%20110.056%2014.5661%20110.056%2014.5661H114.262C117.588%2014.5661%20120%2011.975%20120%208.79414C120%205.61333%20117.588%203.04009%20114.262%203.04009L114.257%203.04456ZM114.257%2013.8155H111.815V3.79509H114.257C116.931%203.79509%20118.468%205.44804%20118.468%208.79861C118.468%2012.1492%20116.931%2013.8155%20114.257%2013.8155Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M59.4369%2013.8155V9.04879H61.742C63.2165%209.05772%2063.5807%209.34364%2063.5807%209.34364V8.00341C63.5807%208.00341%2063.2121%208.29826%2061.6798%208.29826H59.4369V3.79509H63.3187C64.851%203.79509%2065.2196%204.31331%2065.2196%204.31331C65.1574%203.68787%2064.9087%203.04456%2064.9087%203.04456H57.6736C57.8291%203.60299%2057.909%204.21056%2057.909%205.51952V12.0911C57.909%2013.9272%2057.6736%2014.5661%2057.6736%2014.5661H65.3884C65.3884%2014.5661%2065.5616%2013.9719%2065.5927%2013.2973C65.5927%2013.2973%2065.0153%2013.8155%2063.4874%2013.8155H59.4369Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M46.7877%203.04456H45.7928C45.7928%203.04456%2045.815%203.57618%2045.0422%204.81813L42.7638%208.45909L40.3698%204.81813C39.597%203.57618%2039.6148%203.04456%2039.6148%203.04456H37.4918L41.7866%209.41958V12.0956C41.7866%2013.9317%2041.5513%2014.5705%2041.5513%2014.5705H43.5499C43.5499%2014.5705%2043.3545%2014.0389%2043.3189%2012.5557V9.13367L44.9534%206.47108L45.8816%204.96555C46.2325%204.39372%2047.2496%203.04009%2047.2496%203.04009H46.801L46.7877%203.04456Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M105.006%209.08899L104.793%208.9371C106.609%208.55737%20107.657%207.44945%20107.657%206.01093C107.657%204.46073%20106.161%203.04456%20104.389%203.04456H99.5074C99.6628%203.60299%2099.7428%204.21056%2099.7428%205.51952V12.0911C99.7428%2013.9272%2099.5074%2014.5661%2099.5074%2014.5661H101.506C101.506%2014.5661%20101.297%2014.0076%20101.271%2012.4351V3.79509C101.271%203.79509%20102.146%203.73254%20103.331%203.76382C104.708%203.79509%20106.125%204.12568%20106.125%206.01093C106.125%208.15977%20104.606%208.60651%20103.145%208.78968L106.347%2013.6681C106.658%2014.1149%20106.574%2014.5705%20106.574%2014.5705H109.039C109.039%2014.5705%20108.67%2014.1506%20108.053%2013.4805C106.392%2011.3004%20105.001%209.08899%20105.001%209.08899H105.006Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M36.1416%205.51952C36.1416%203.6834%2036.4125%203.04456%2036.4125%203.04456H34.3784C34.3784%203.04456%2034.5827%203.59405%2034.6137%205.13085V8.29379H28.9332V5.17552C28.9598%203.60299%2029.1686%203.04456%2029.1686%203.04456H27.1699C27.3254%203.60299%2027.4053%204.21056%2027.4053%205.51952V12.1045C27.4053%2013.9317%2027.1699%2014.5661%2027.1699%2014.5661H29.1686C29.1686%2014.5661%2028.9598%2014.0076%2028.9332%2012.4351V9.04432H34.6093V12.4798C34.5782%2014.0166%2034.3739%2014.5661%2034.3739%2014.5661H36.3726C36.3726%2014.5661%2036.1372%2013.9272%2036.1372%2012.0911V5.51952H36.1416Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M75.5548%2013.4715C74.1424%2011.9347%2072.5391%209.18728%2072.4947%209.1158C72.4103%208.98624%2072.2637%208.9371%2072.2637%208.9371C74.0802%208.55737%2075.1284%207.44945%2075.1284%206.01093C75.1284%204.46074%2073.6317%203.04456%2071.8595%203.04456H66.9784C67.1339%203.60299%2067.2138%204.21056%2067.2138%205.51952V12.0911C67.2138%2013.9272%2066.9784%2014.5661%2066.9784%2014.5661H68.977C68.977%2014.5661%2068.7683%2014.0076%2068.7416%2012.4351V3.79509C68.7416%203.79509%2069.6166%203.73254%2070.8025%203.76382C72.1793%203.79509%2073.5961%204.12568%2073.5961%206.01093C73.5961%208.15977%2072.0772%208.60651%2070.6159%208.78968C70.6159%208.78968%2072.9388%2012.5021%2073.796%2013.5207C74.5954%2014.4722%2075.6481%2014.8833%2077.2026%2014.6018L77.1892%2014.5348C76.4431%2014.365%2076.1366%2014.1149%2075.5459%2013.4715H75.5548Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.75711%202.79614V5.4415C8.83276%205.43636%208.90841%205.43379%208.98494%205.43379C9.06147%205.43379%209.13712%205.43636%209.21277%205.4415V2.72075C9.36671%202.72589%209.51801%202.73703%209.66932%202.7533V0.024843C9.44324%200.00856647%209.21541%200%208.98494%200C8.75447%200%208.52664%200.00856647%208.30057%200.024843V2.7533C8.45099%202.73703%208.60317%202.72589%208.75711%202.72075V2.79528V2.79614ZM6.82353%203.09426L6.84728%203.16622L7.68736%205.68309C7.84658%205.61884%208.01283%205.56658%208.18349%205.52632L7.34341%203.0086L7.31966%202.93749C7.44545%202.90323%207.57212%202.87239%207.70055%202.84669L6.83497%200.252723C6.40921%200.354665%205.99489%200.485734%205.59465%200.644216L6.46023%203.23904C6.57899%203.18678%206.70038%203.13881%206.82353%203.09426ZM5.11068%204.04259L5.15467%204.10084L6.75477%206.24506C6.90255%206.12084%207.06089%206.00776%207.2289%205.90925L5.6288%203.76503L5.58482%203.70678C5.67542%203.64767%205.76691%203.59199%205.86191%203.53887L4.21607%201.33297C3.86509%201.54714%203.53082%201.78443%203.21502%202.04229L4.86086%204.24819C4.94267%204.17794%205.02536%204.10855%205.11068%204.04259ZM3.84676%205.5066L3.78783%205.46462L3.78695%205.46548C3.73944%205.53658%203.6937%205.60939%203.64972%205.68221L1.38548%204.08026C1.59395%203.7573%201.8253%203.44804%202.07513%203.15592L4.33937%204.75787C4.28131%204.82127%204.22502%204.88637%204.17048%204.95234L4.22941%204.99346L6.43384%206.55343C6.29046%206.71106%206.16203%206.88325%206.05031%207.06657L3.84676%205.5066ZM2.99076%207.21993L3.06025%207.24134L5.65437%208.06202C5.70363%207.83073%205.7784%207.60885%205.87604%207.39811L3.28104%206.57743L3.21243%206.55602C3.23618%206.49691%203.26081%206.4378%203.28632%206.37954L0.624473%205.53745C0.489885%205.86983%200.37465%206.21164%200.282286%206.56201L2.94414%207.40497C2.95821%207.34243%202.97404%207.28161%202.99076%207.21993ZM5.60343%209.13026H2.8026V9.13198C2.80523%209.17481%202.80875%209.21679%202.81227%209.25876H0.0149542C0.00527796%209.09%200%208.9221%200%208.75076C0%208.57943%200.00527796%208.41067%200.0149542%208.24277H2.81227C2.80875%208.28474%202.80523%208.32672%202.8026%208.36955H5.60343C5.58848%208.49377%205.58056%208.62141%205.58056%208.74991C5.58056%208.87841%205.58848%209.00519%205.60343%209.13026ZM3.30063%2010.9815L3.23672%2011.002C3.24453%2011.0214%203.25236%2011.0409%203.26104%2011.0603L0.600953%2011.9016C0.483958%2011.6077%200.383677%2011.3062%200.29923%2010.9969L2.95932%2010.1557L2.97515%2010.2174L3.03937%2010.1968L5.64052%209.37355C5.69418%209.64854%205.78303%209.91239%205.90266%2010.1583L3.30063%2010.9815ZM4.30778%2012.6083L4.25588%2012.6452L4.17583%2012.7008L1.99339%2014.2445C1.80251%2014.0141%201.62394%2013.7742%201.4568%2013.5258L3.64012%2011.9813L3.71841%2011.9264L3.77119%2011.8887L5.98705%2010.321C6.13307%2010.584%206.3134%2010.8256%206.52364%2011.0398L4.30778%2012.6083ZM14.4166%205.84756L16.687%204.24132C16.417%203.80443%2016.1091%203.39323%2015.7669%203.0103L13.4965%204.61654C13.8545%204.98576%2014.1633%205.39953%2014.4166%205.84756ZM12.4925%203.77846L12.4463%203.84042L10.8524%205.97779C10.9438%206.03518%2011.0309%206.09858%2011.1154%206.16454L12.7102%204.02717L12.7568%203.96464C12.9125%204.08114%2013.0621%204.2045%2013.2054%204.33471L14.8539%202.12453C14.4757%201.80757%2014.071%201.51973%2013.6418%201.26616L11.9942%203.47634C12.1655%203.56878%2012.3317%203.66977%2012.4925%203.77846ZM10.2207%205.65995C10.1002%205.61369%209.97612%205.57429%209.84945%205.54259H9.85033L10.6886%203.0283L10.7133%202.95462C10.5461%202.90751%2010.3772%202.86724%2010.2048%202.83383L11.0713%200.2373C11.541%200.346096%2011.9967%200.490871%2012.4348%200.6682L11.5674%203.26559C11.41%203.19363%2011.249%203.13024%2011.0845%203.07284L11.0599%203.14652L10.2207%205.65995ZM6.60883%2011.1246L4.95947%2013.3356L4.97559%2013.3492C4.9866%2013.3585%204.99747%2013.3678%205.00873%2013.3759L4.95243%2013.4521L3.36641%2015.5783C3.58632%2015.7505%203.81503%2015.9124%204.05166%2016.0641L5.63857%2013.937L5.69399%2013.8616L5.71247%2013.8729C5.72478%2013.8805%205.73709%2013.8881%205.7494%2013.895L7.39877%2011.684C7.10848%2011.5349%206.84194%2011.3456%206.60883%2011.1246ZM15.1758%208.55891H15.2602L15.2611%208.55634H17.9678C17.9705%208.61974%2017.9705%208.68313%2017.9705%208.74652C17.9705%208.80991%2017.9696%208.87331%2017.9678%208.9367H15.1767C15.1714%209.10803%2015.1582%209.27765%2015.1388%209.4447H13.4041L15.0535%209.9664C15.0218%2010.112%2014.9858%2010.2568%2014.9444%2010.399L15.0236%2010.4247L17.5992%2011.2394C17.5561%2011.3816%2017.5086%2011.523%2017.4585%2011.6617L14.882%2010.8471L14.8028%2010.8214C14.75%2010.961%2014.692%2011.0989%2014.6295%2011.2334L12.7787%2010.6483L14.3507%2011.7602C14.2856%2011.8708%2014.2161%2011.9796%2014.1439%2012.0849L14.2134%2012.1346L16.4029%2013.6834C16.3044%2013.8231%2016.2023%2013.9602%2016.0959%2014.0938L13.9073%2012.5449L13.8369%2012.4953C13.756%2012.5955%2013.6716%2012.6932%2013.5836%2012.7874L11.8436%2011.5555L13.1068%2013.2483C13.0259%2013.3194%2012.9423%2013.3888%2012.857%2013.4539L12.9089%2013.5233L14.4984%2015.6538C14.3445%2015.7711%2014.1862%2015.8834%2014.0243%2015.9904L12.4348%2013.8591L12.3837%2013.7897C12.2931%2013.8488%2012.1999%2013.9045%2012.1058%2013.9576L10.7177%2012.0969L11.4469%2014.2831C11.3668%2014.3174%2011.2868%2014.3491%2011.205%2014.3799L11.2323%2014.4622L12.0679%2016.967C11.8647%2017.0398%2011.658%2017.1058%2011.4487%2017.1632L10.613%2014.6583L10.5857%2014.5761C10.5013%2014.5984%2010.4168%2014.6189%2010.3315%2014.6369L9.53716%2012.2563V14.756C9.47294%2014.7611%209.40785%2014.7663%209.34187%2014.7697V17.4904C9.224%2017.4947%209.10349%2017.4973%208.98385%2017.4973C8.86422%2017.4973%208.74458%2017.4947%208.62583%2017.4904V14.7697C8.55986%2014.7671%208.49476%2014.762%208.43055%2014.756V12.0515L7.572%2014.6223C7.55792%2014.6189%207.54375%2014.6156%207.52958%2014.6123C7.50123%2014.6056%207.47289%2014.5989%207.44533%2014.5915L7.4163%2014.6772L6.5815%2017.1795C6.32816%2017.1118%206.0801%2017.033%205.83731%2016.9448L6.67299%2014.4416L6.70202%2014.3568C6.66155%2014.3414%206.62109%2014.3251%206.58062%2014.3088L7.44885%2011.7071C7.75233%2011.8571%208.0822%2011.9641%208.43055%2012.019V11.9838H8.45254L8.44022%2012.0207C8.61791%2012.0489%208.8%2012.0635%208.98473%2012.0635C9.14747%2012.0635%209.30669%2012.0524%209.46327%2012.031C9.48878%2012.0275%209.51341%2012.0241%209.53892%2012.0198C9.86087%2011.9684%2010.1679%2011.8733%2010.4529%2011.7405C10.4951%2011.7208%2010.5382%2011.7003%2010.5796%2011.678C10.8443%2011.5418%2011.088%2011.3713%2011.3053%2011.1743C11.3563%2011.128%2011.4056%2011.0809%2011.4539%2011.0312C11.6431%2010.8368%2011.8084%2010.62%2011.9457%2010.3853C11.9905%2010.3082%2012.0328%2010.2294%2012.0715%2010.148C12.1788%209.92614%2012.2606%209.69142%2012.3142%209.44556C12.3371%209.33847%2012.3556%209.22882%2012.3679%209.11745C12.382%208.99581%2012.389%208.87245%2012.389%208.74738C12.389%208.64201%2012.3837%208.53664%2012.3732%208.43298C12.3609%208.30363%2012.3406%208.17513%2012.3134%208.05006C12.236%207.69626%2012.1005%207.36473%2011.9175%207.06319L11.914%207.05376L14.6022%206.2031C14.6849%206.37614%2014.7597%206.55262%2014.8248%206.73337L14.9031%206.70853L17.4805%205.89299C17.5157%205.99322%2017.5491%206.09345%2017.5808%206.19539L15.0034%207.01093L14.926%207.03577C14.9805%207.21824%2015.028%207.40328%2015.0649%207.59174L13.6161%208.05091H15.1379C15.1573%208.21796%2015.1705%208.38758%2015.1758%208.55891Z'%20fill='white'/%3e%3c/svg%3e", It = ({ className: e }) => /* @__PURE__ */ _.jsx("img", { src: jt, className: F("h-5", e) }), Pt = {
  light: {
    outerRingStyle: "bg-white/50",
    innerRingStyle: "bg-white"
  },
  dark: {
    outerRingStyle: "bg-black/25",
    innerRingStyle: "bg-black/50"
  }
}, Ot = ({ className: e, colorVariant: t = "light" }) => {
  const n = Or(
    () => Pt[t],
    [t]
  );
  return /* @__PURE__ */ _.jsxs(
    "div",
    {
      className: F(
        "relative h-6 w-6 animate-spin mix-blend-hard-light",
        e
      ),
      children: [
        /* @__PURE__ */ _.jsx(
          "div",
          {
            className: F(
              "absolute h-full w-full rounded-full",
              n.outerRingStyle
            )
          }
        ),
        /* @__PURE__ */ _.jsx(
          "div",
          {
            className: F(
              "absolute h-1/2 w-1/2 rounded-tl-full",
              n.innerRingStyle
            )
          }
        ),
        /* @__PURE__ */ _.jsx("div", { className: "absolute left-1/2 top-1/2 h-3/4 w-3/4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[gray]" })
      ]
    }
  );
};
export {
  je as Body,
  Ft as Button,
  Nt as Checkbox,
  Ht as Heading,
  Dt as Input,
  It as Logo,
  Ot as Spinner,
  Vt as Superscript,
  At as twTheme
};
//# sourceMappingURL=index.es.js.map
